'use strict';

var generatedCraftcms = require('@liquorice/generated-craftcms');

const FORMIE_FORM_QUERY = generatedCraftcms.gql(`
  query formieForm($id: [QueryArgument], $uid: [String]) {
    formieForm(id: $id, uid: $uid) {
      __typename
      id
      ...formieForm
    }
  }
`);

exports.FORMIE_FORM_QUERY = FORMIE_FORM_QUERY;
